import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useScrollToGridItem = (gridRef) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const scrollToItemId = state?.scrollToItemId;

  useEffect(() => {
    if (scrollToItemId && gridRef.current?.scrollToItem(scrollToItemId)) {
      navigate('.', { replace: true, state: null });
    }
  });
};

export default useScrollToGridItem;
